export default {
  error: null,
  isLoading: false,
  propertyProfilePrices: null,
  propertyProfilePrice: null,
  updateProfilePriceSuccess: false,
  updateProfilePriceError: false,
};
